import { IPatient } from '~/interfaces'

interface Child extends Omit<IPatient, 'hasPregnancies'> {}

interface IFetchPregnancy {
  pregnancyId: number
  motherId: number
  childrenIds?: number[] // TODO: remover campo
  children: Child[]

  dum: string
  dppByDum: string
  dppByUsg: string
  dateOfDelivery: string
  typeOfDelivery: string
  startDate: string
  endDate: string

  // TODO: Validar esses campos, pois os mesmos não vem da API
  dpp?: string
  pregnancyPeriodEnd?: string
  pregnancyPeriod?: string

  mother?: IPatient // TODO: remover esse atributo quando dividir o contexto da materno-infantil
}

// TODO: Passar os campos de IFetchPregnancy para IPregnancy
// TODO: Após passo anterior, remover IFetchPregnancy
interface IPregnancy extends IFetchPregnancy {}

interface IGetPatientChildrenParams {
  id: number
}

interface IGetPatientPregnanciesParams {
  patientId: number
}

interface IGetPregnancyByIdParams {
  id: number
}

interface IFetchPregnancyById {
  motherId?: number
  startDate: string
  endDate: string
  mother?: IPatient
}

type BirthPregnancy = {
  child: IPatient
  mother: IPatient
  pregnancyId: number
  startDate: string
  endDate: string
}

type PathParam = {
  childId: number
}

type BirthPregnancyFetchParams = {
  pathParam: PathParam
}

export const isMultiplePregnancy = (pregnancy: IFetchPregnancy): boolean => {
  const { children } = pregnancy
  if (!children) return false
  return children.length > 1
}

export const isSingletonPregnancy = (pregnancy: IFetchPregnancy): boolean => {
  const { children } = pregnancy
  if (!children) return false
  return children.length === 1
}

export const isPregnancyWithAnyBaby = (pregnancy: IFetchPregnancy): boolean => {
  const { children } = pregnancy
  if (!children) return false
  return children.length >= 1
}

export const isPregnancyWithoutBaby = (pregnancy: IFetchPregnancy): boolean => {
  const { children } = pregnancy
  if (!children) return false
  return children.length === 0
}

export const getIndexSelectedBaby = (selectedPregnancy: IFetchPregnancy, selectedBaby: number | null): string => {
  const { children } = selectedPregnancy

  if (!children) return ''

  if (isMultiplePregnancy(selectedPregnancy)) {
    return `${selectedPregnancy.children.findIndex(c => c.id === selectedBaby) + 1}`
  }

  return ''
}

export const getBabySelectedNameByIndex = (selectedPregnancy: IFetchPregnancy, index: number): string => {
  const { children } = selectedPregnancy

  if (!children) return ''

  if (children[index]) {
    const name = children[index].name
    const firstName = name.split(' ')[0]
    return firstName
  }

  return ''
}

export type {
  Child,
  IFetchPregnancy,
  IPregnancy,
  IGetPatientChildrenParams,
  IGetPatientPregnanciesParams,
  IGetPregnancyByIdParams,
  IFetchPregnancyById,
  BirthPregnancy,
  BirthPregnancyFetchParams
}
